<template>
    <div>
        <CRow>
            <CCol>
                <div class="col-lg-12 control-section" style="padding:10px; position:relative;">
                    <div style="width:100%; height: 74vh;">
                        <ejs-grid ref='grid'
                                  :dataSource='data'
                                  :toolbar='toolbar'
                                  :pageSettings='pageSettings'
                                  :filterSettings='filterOptions'
                                  :toolbarClick='toolbarClick'
                                  :query='query'
                                  :allowFiltering='true'
                                  :allowPaging='true'
                                  :allowResizing='true'
                                  :allowReordering='true'
                                  :allowSorting='true'
                                  :allowExcelExport='true'
                                  :excelExportComplete='excelExportComplete'
                                  :allowTextWrap='true'
                                  :textWrapSettings='wrapSettings'
                                  :actionBegin='actionBegin'
                                  :actionComplete='actionComplete'
                                  :actionFailure='actionFailure'
                                  :enablePersistence="true"
                                  :queryCellInfo='customiseCell' width="100%" height="100%">
                            <e-columns>
                                <e-column field='templateTypeName' headerText='Type' width="80" type="string"></e-column>
                                <e-column field='originaFileName' headerText='File Name' width="150" type="string"></e-column>
                                <e-column field='createdBy' headerText='Created By' width="250" type="string"></e-column>
                                <e-column field='createdDate' headerText='Created At' width="130" format="dd/MM/yyyy HH:mm" type="dateTime"></e-column>
                                <e-column field='templateUploadStatusName' headerText='Upload Status' width="150" type="string" textAlign="Center" template="<span class='status-badge ${templateUploadStatusName}'>${templateUploadStatusName}</span>"></e-column>
                                <e-column field='insertLog' headerText='Insert Log' width="180" type="string"></e-column>
                                <e-column field='errorLog' headerText='Error Log' width="180" type="string" template="<span title='${errorLog}'>${errorLog}</span>"></e-column>
                                <e-column headerText='Download' width='80' textAlign='Center' :template='downloadTemplate'></e-column>
                            </e-columns>
                        </ejs-grid>

                        <div id="uploadToolbarItemUploads">
                            <div style="display: flex; gap: 16px; align-items: center;">
                                <div class="upload-section-separator"></div>

                                <ejs-uploader ref="refTradeUploader"
                                              id='uploadTradesFiles'
                                              name="tradeFiles"
                                              :buttons="{browse: 'Select Trades Files'}"
                                              :asyncSettings="path"
                                              :allowedExtensions="extensions"
                                              :multiple="true"
                                              :showFileList="false"
                                              :autoUpload="false"
                                              :selected="onFileSelected"
                                              :failure="onUploadFailure">
                                </ejs-uploader>
                                <button :disabled="!isUploading" @click="uploadTradesFilesClick" class="e-btn e-primary">Upload Trades</button>
                                <div class="upload-section-separator"></div>
                                <ejs-uploader ref="refVolumesUploader"
                                              id="uploadVolumesFile"
                                              name="volumesFile"
                                              :buttons="{ browse: 'Upload Volumes'}"
                                              :asyncSettings="bulkVolumesPath"
                                              :allowedExtensions="volumesExtension"
                                              :multiple="false"
                                              :showFileList="false"
                                              :autoUpload="false"
                                              :selected="onVolumeFileSelected">
                                </ejs-uploader>
                                <div class="upload-section-separator"></div>
                                <!--<ejs-uploader ref="refPriceUploader"
                  id='uploadPricesFile'
                  name="priceFile"
                  :buttons="{browse: 'Select Price File'}"
                  :asyncSettings="path"
                  :allowedExtensions="extensions"
                  :multiple="true"
                  :showFileList="false"
                  :autoUpload="false"
                  :selected="onFileSelected"
                  :failure="onUploadFailure">
    </ejs-uploader>-->
                            </div>
                        </div>
                    </div>
                    <br />
                    <button @click="downloadTradeTemplateFile" class="e-btn e-primary">Download Trade Template</button>
                </div>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import gridOptions from '../common/gridOptions'
    import SyncHelper from '../common/syncfusion'
    import apis from '../common/network'
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { UploaderComponent } from "@syncfusion/ej2-vue-inputs";
    import urls from '../common/urls'
    import authToken from '@/common/authToken';
    import RMErrorType from '@/common/errorTypes';

    Vue.use(ButtonPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    //Vue.use(UploaderComponent);

    export default {
        components: {
            "ejs-uploader": UploaderComponent
        },
        name: 'Trades',
        data() {
            return {
                data: SyncHelper.getDataManager("Upload/getUploadedTemplates"),
                query: new Query(),
                pageSettings: gridOptions.pageSettings,
                uploadProgress: "Uploading file ...",
                uploadInsertLog: "",
                toolbar: [
                    { text: 'Refresh', tooltipText: 'Reload Grid', prefixIcon: 'e-refresh', id: 'RefreshGrid' },
                    {
                        text: "Upload File",
                        template: "#uploadToolbarItemUploads", // Use the div as template
                    },
                ],

                filterOptions: gridOptions.filterSettings,
                //dateFormatOptions: { type: 'dateTime', format: 'dd/MM/yyyy HH:mm' },
                path: {
                    saveUrl: `${urls.apiBaseUrl}trade/bulkTradeCreate`
                },
                pathConfirmationFiles: {
                    saveUrl: `${urls.apiBaseUrl}trade/UploadConfirmationTradeFiles`
                },
                bulkVolumesPath: {
                    saveUrl: `${urls.apiBaseUrl}volume/bulkImportVolumes`,

                },
                isUploading: false, // reset
                extensions: '*',
                volumesExtension: '.xlsx',
                wrapSettings: { wrapMode: 'Header' },
                mounted() {
                    createSpinner({
                        target: document.getElementById('mainSpinner'),
                        width: '50',
                        type: 'Material',
                        label: 'Loading data...',
                        cssClass: 'loading',

                    });
                },
                downloadTemplate: function () {
                    return {
                        template: Vue.component('columnTemplate', {
                            template: `
                                        <a :href="data.fileUrl" target="_blank"
                                           class="e-btn e-flat e-primary"
                                           style="padding:0px 12px; font-size:20px">
                                          <strong><span class="e-icons e-download"></span></strong>
                                        </a>`,
                            data: function () {
                                return {
                                    data: {}
                                }
                            },
                        })
                    }
                }
            }
        },
        methods: {
            dataBound: function () {
                this.$refs.grid.autoFitColumns();
            },

            downloadTradeTemplateFile() {


                apis.protectedApi(`${urls.apiBaseUrl}Trade/getTradeTemplateFile`,
                    { responseType: 'blob' }).then(
                        it => {
                            var blob = new Blob([it.data], { type: 'application/' + it.headers['content-type'] })
                            var downloadElement = document.createElement('a')
                            var href = window.URL.createObjectURL(blob) // Create a downloaded link
                            downloadElement.href = href
                            downloadElement.download = "TradesTemplate.xlsx"; // filename after download
                            document.body.appendChild(downloadElement)
                            downloadElement.click() // Click to download
                            document.body.removeChild(downloadElement)
                        }).catch(
                            response => {
                                var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                gridOptions.errorAlert("Error: " + message);
                            }
                        );

            },

            async uploadTradesFilesClick() {
                if (!this.formData) {
                    this.showAlertMessage('Alert Dialog', 'No files selected.');
                    return;
                }
                try {
                    this.isUploading = false;
                    const response = await fetch(this.path.saveUrl, {
                        method: "POST",
                        headers: {
                            "Authorization": `Bearer ${authToken.get()}`
                        },
                        body: this.formData
                    });
                    if (response.ok) {
                        let message = { title: 'Success!', content: `Trade upload is finished`, cssClass: 'e-toast-success' };
                        this.$root.$emit('showToast', message);
                    }
                    else {
                        const errorMessage = await response.text();
                        this.showAlertMessage('Upload Trades Alert', errorMessage);
                    }
                    this.$refs.grid.refresh();
                    //this.isUploading = true;
                    this.formData = null;
                    this.$refs.refTradeUploader.clearAll();

                }
                catch (error) {
                    console.log(error);
                    if (error.message === 'Failed to fetch') {
                        return;
                    }
                    DialogUtility.alert({
                        title: 'Error',
                        content: `Upload failed.`,
                        position: { X: 700, Y: 200 },
                        showCloseIcon: true,
                        closeOnEscape: true,
                        animationSettings: { effect: 'Zoom' },
                        zIndex: 1100
                    });
                }
                finally {
                    //this.isUploading = true;
                    this.formData = null;
                    this.$refs.refTradeUploader.clearAll();
                }
            },
            onFileSelected(args) {

                let errorMessage = "";


                //check extensions
                const allowedExtensions = ['.xlsx', '.txt', '.docx', '.pdf', '.msg', '.eml', '.png', '.jpg', '.xls', '.csv', '.zip'];
                const allowedExtensionsMessage = allowedExtensions.join(', ');
                const invalidFiles = args.filesData.filter(file => {
                    const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
                    return !allowedExtensions.includes(ext);
                });

                if (invalidFiles.length > 0) {
                    this.showAlertMessage('Alert Dialog','Some files have an invalid extension. Allowed: ' + allowedExtensionsMessage);
                    args.cancel = true;
                    this.isUploading = false;
                    return
                }

                //check number of files and total size
                const maxFiles = 201;          // Max number of files
                const maxTotalSizeMB = 200;     // Max total upload size in MB
                const totalFiles = args.filesData.length;
                if (totalFiles > maxFiles) {
                    this.showAlertMessage('Alert Dialog', 'You can upload only up to ' + maxFiles + ' files.');
                    this.isUploading = false;
                    args.cancel = true;
                    return;
                }

                const totalSize = args.filesData.reduce((sum, f) => sum + f.size, 0);

                if (totalSize > maxTotalSizeMB * 1024 * 1024) {
                    this.showAlertMessage('Alert Dialog', 'Total file size must be under ' + maxTotalSizeMB + ' MB.');
                    this.isUploading = false;
                    args.cancel = true;
                    return;
                }

                //check size
                const maxFileSizeMB = 10; // max size allowed (e.g. 5 MB)
                const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;

                // check each file
                const oversizedFiles = args.filesData.filter(f => f.size > maxFileSizeBytes);

                if (oversizedFiles.length > 0) {
                    const oversizedFilesMessage = `These files exceed ${maxFileSizeMB} MB: ${oversizedFiles.map(f => f.name).join(', ')}`;
                    this.showAlertMessage('Alert Dialog',oversizedFilesMessage);
                    this.isUploading = false;
                    args.cancel = true;
                    return;
                }


                const tradesFiles = args.filesData.filter(f =>
                    f.name.toLowerCase().startsWith("trades") &&
                    f.name.toLowerCase().endsWith(".xlsx")
                );

                const hasTradesFile = tradesFiles.length === 1;


                if (!hasTradesFile) {
                    this.showAlertMessage('Alert Dialog',"You must select exactly one Trades Excel file.");
                    args.cancel = true; // stop upload
                    this.isUploading = false;
                    return
                }
                this.isUploading = true;
                this.formData = new FormData(); // reset
                args.filesData.forEach(file => {
                    this.formData.append("tradeFiles", file.rawFile, file.name);
                });

            },

            showAlertMessage(title, alertMessage) {
                DialogUtility.alert({
                    title: title,
                    content: alertMessage,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },

            toolbarClick(args) {

                if (args.item.id === 'RefreshGrid') {
                    this.$refs.grid.refresh();
                }
                if (args.item.id.indexOf("excelexport") !== -1) {
                    gridOptions.excelExport(args, "Trade.xlsx", this.$refs);
                }
            },

            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            customiseCell: function (args) { // when setting up the grid this is rendering each column on its own
                if (args.column.field === 'price') {
                    args.cell.textContent = args.cell.textContent + ' ' + args.data['currencySymbol'] + "/" + args.data['tradingUnit'];
                }
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);

            },

            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args, this.$refs);
            },

            onUploadFailure() {
                let message = { title: 'Warning !', content: `Trade files are incomplete`, cssClass: 'e-toast-warning' };
                this.$root.$emit('showToast', message);
            },
            async onVolumeFileSelected(args) {

                const numOfFilesSelected = args.filesData.length;

                if (numOfFilesSelected !== 1) {
                    this.showAlertMessage('Alert Dialog', "You must select exactly one Import Bulk Volumes Excel file.");
                    args.cancel = true; // stop upload
                    return
                }
                const file = args.filesData[0];

                const isValid = file?.name?.toLowerCase().endsWith('.xlsx');

                if (!isValid) {
                    this.showAlertMessage('Alert Dialog', 'Please select Volume Excel file.');
                    args.cancel = true;
                    return;
                }

                const maxTotalSizeMB = 10;
                if (file.size > maxTotalSizeMB * 1024 * 1024) {
                    this.showAlertMessage('Alert Dialog', `File size must be under ${maxTotalSizeMB} MB.`);
                    args.cancel = true;
                    return;
                }

                let fd = new FormData();

                args.filesData.forEach(file => {
                    const realFile = file.blobFile || file.rawFile;
                    if (realFile instanceof Blob) {
                        fd.append('volumesFile', realFile, file.name);
                    }
                });

                try {

                    const res = await fetch(this.bulkVolumesPath.saveUrl, {
                        method: "POST",
                        headers: {
                            "Authorization": `Bearer ${authToken.get()}`
                        },
                        body: fd
                    });

                    const text = await res.text();
                    let responseData = null;

                    try {
                        responseData = JSON.parse(text);

                    } catch {

                    }
                    if (responseData.status == 'OK') {
                        var contentMs = responseData?.message || text || 'Volume upload is finished';
                        let message = { title: 'Success!', content: contentMs, cssClass: 'e-toast-success' };
                        this.$root.$emit('showToast', message);
                    }

                    if (!res.ok) {
                        throw new Error(responseData?.message || text || "Upload failed");
                    }

                } catch (e) {
                    DialogUtility.alert({
                        title: 'Error',
                        content: e.message,
                        position: { X: 700, Y: 200 },
                        showCloseIcon: true,
                        closeOnEscape: true,
                        animationSettings: { effect: 'Zoom' },
                        zIndex: 1100
                    });

                } finally {
                    this.$refs.grid.refresh();
                    this.formData = null;
                    this.$refs.refVolumesUploader?.clearAll();
                }
            },
            onVolumeUploadFailure(args) {
                const errorMessage = args?.response?.toString?.() || 'Upload failed.';
                this.showAlertMessage('Upload Volumes Alert', errorMessage);
                this.$refs.refVolumesUploader?.clearAll?.();
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style>
    .e-file-drop {
        display: none !important;
    }

    .wrap-text {
        white-space: normal !important;
        word-wrap: break-word;
        overflow-wrap: break-word;
        display: block;
        max-height: 80px;
        overflow-y: auto;
    }

    .e-upload {
        border: none !important;
        box-shadow: none !important;
        background: transparent !important;
        padding: 0 !important;
    }

    .uploder-trade-file {
        display: none;
        width: auto;
    }

    .e-file-select-wrap {
        padding-left: 0px !important;
    }

    .fullscreen-spinner {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(255, 255, 255, 0.6);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        pointer-events: all;
    }

    .spinner-container {
        background: white;
        padding: 20px 40px;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }

    .spinner {
        width: 60px;
        height: 60px;
        border: 6px solid #ccc;
        border-top: 6px solid #007bff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    .progress-message {
        font-size: 1.2em;
        font-weight: bold;
        color: #333;
        text-align: center;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    /*    .status-badge {
        display: inline-block;
        padding: 4px 8px;
        width: 100px;
        border-radius: 4px;
        color: #fff;
        background: gray;
        text-align: center;
    }*/
    .status-badge {
        /* default: no background, just plain text */
        display: inline-block;
        padding: 0;
        border-radius: 0;
        background: none;
        color: inherit;
        font-size: 14px;
        line-height: 22px;
        overflow: initial;
    }

        .status-badge.Completed {
            display: inline-block;
            width: 100px; /* same width for all */
            text-align: center; /* center text */
            background: green;
            color: #fff;
            padding: 4px 8px;
            border-radius: 4px;
        }

        .status-badge.Failed {
            display: inline-block;
            width: 100px;
            text-align: center;
            background: red;
            color: #fff;
            padding: 4px 8px;
            border-radius: 4px;
        }

    .upload-section-separator {
        width: 2px;
        height: 40px;
        background-color: #6c757d;
        margin-left: 5px;
        margin-right: 5px
    }
</style>